import React, { useEffect, useState } from "react";
import { Player } from "video-react";
import { iconData } from "../../../../iconData";
import PdfViewer from "../../../PdfViewer/PdfViewer";
import axios from "../../../../axios";
import Camera from "react-html5-camera-photo";
import "react-html5-camera-photo/build/css/index.css";
import { useSelector } from "react-redux";
import { IP } from "../../../../internalServer";
import { toast } from 'react-toastify';

export default function SubmisshionByUpload({
  question,
  questionNo,
  setQuestionsAnswer,
  questionsAnswer,
  receiveDataFromChild,
  pendingData,
  saveAnswersToLocalStorage
}) {
  const [mideaviewer, setMideaviewer] = useState(false);
  const [responseAttach, setResponseAttach] = useState();
  const userId = useSelector((state) => state?.user?.currentUser?.id);
  const [isValidFileType, setIsValidFileType] = useState(true);
  const [pedingSubDetail, setPedingSubDetail] = useState({
    pdfView: false,
    attachment: null,
  });
  const [attachMent, setAttachment] = useState([]);

  const [isClicked, setIsClicked] = useState(false);
  const handleClick = (attachment) => {
    setResponseAttach(attachment);
    setIsClicked(!isClicked);
  };

  const poster =
    "https://images.unsplash.com/photo-1431499012454-31a9601150c9?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80";

  const [isOpen, setIsOpen] = useState(false);
  const [isCameraOpen, setIsCameraOpen] = useState();
  const [attachedFiles, setAttachedFiles] = useState([]);
  const [attachmentSize, setAttachmentSize] = useState([]);
  const [isError, setIsError] = useState(false);
  const [photo, setPhoto] = useState(null)
  const [attachFile, setAttachFile] = useState(
    questionsAnswer.find((i) => i.question_id === question?.id)?.attachments
      ?.length > 0
      ? questionsAnswer.find((i) => i.question_id === question?.id)?.attachments
      : []
  );
  const [answerLimit, setAnswerLimit] = useState(
    question?.type?.maxLimit ? question?.type?.maxLimit : 2500
  );

  useEffect(() => {
    setAnswerLimit(question?.type?.maxLimit);
  }, [question?.type]);

  const handleRemovePdfVivwer = () => {
    setPedingSubDetail({
      ...pedingSubDetail,
      pdfView: false,
      attachment: null,
    });
    setIsOpen(null);
  };

  useEffect(() => {
    !questionsAnswer.find((i) => i.question_id === question?.id) &&
      setQuestionsAnswer((prev) => [
        ...prev,
        {
          question_id: question?.id,
          descriptive_answer: null,
          attachments: prev?.attachments?.length > 0 ? prev?.attachments : [],
        },
      ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleAttachment = async (files) => {
    let attachments = [];
    let attachmentSizes = [];
    const totalSize = attachedFiles.reduce(
      (accumulator, current) => accumulator + current.size,
      0
    );
    if (files) {
      for (const file of files) {
        if (
          totalSize + file.size < 10 * 1024 * 1024 &&
          validateFileType(file)

        ) {
          try {
            // Check if the file is already uploaded
            // const isFileAlreadyUploaded = attachMent.some(
            //   (uploadedFile) =>
            //     uploadedFile.name === file.name &&
            //     uploadedFile.size === file.size
            // );

            // if (isFileAlreadyUploaded) {
            //   console.log("File already uploaded");
            //   // setIsValidFileType(false);
            //   return;
            // }
            let formData = new FormData();
            formData.append("name", file.name);
            formData.append("uploadResponseAttachment", file);
            let res = await axios.post(
              `/activity/studentResponse/uploadAttachment/studentId/${userId}`,
              formData
            );
            res && setAttachmentSize((prev) => [...prev, file.size]);
            res && setAttachment((prev) => [...prev, file]);
            res && attachments.push(res.data.data);
            res &&
              setAttachedFiles((prev) => {
                receiveDataFromChild([...prev, file]);
                attachmentSizes.push(...attachmentSize, file.size);
                return [...prev, file];
              });
          } catch (error) {
            console.log(error);
          }
        } else {
          setIsValidFileType(false);
        }
      }
      if (attachments.length > 0) {
        setAttachFile((prev) => [...prev, ...attachments]);
        console.log(questionsAnswer);
        setQuestionsAnswer((prev) => {
          let updatedData = prev.map((item) => {
            if (item.question_id === question?.id) {
              return {
                ...item,
                attachments: [...(item?.attachments || []), ...(attachments || [])],
                attachments_sizeKb: attachmentSizes,
              };
            }
            return item;
          });

          if (!updatedData.some((item) => item.question_id === question?.id)) {
            updatedData.push({
              question_id: question?.id,
              attachments: attachments || [],
              attachments_sizeKb: attachmentSizes || [],
            });
          }
          const validQuestions = updatedData.filter(
            (q) =>
              q.attachments &&
              q.attachments.length > 0
          );
          saveAnswersToLocalStorage(validQuestions, pendingData?.id)
          return updatedData;
        });
      }
    }
  };

  const handleRemoveAttachment = async (attachment, index) => {
    try {
      let res = await axios.delete(`/file/delete`, {
        data: { file_path: attachment },
      });
      const newArrayLimit = [...attachedFiles];
      newArrayLimit.splice(index, 1);
      const newAttSize = [...attachmentSize];
      newAttSize.splice(index, 1);
      setAttachmentSize(newAttSize);
      const newAtt = [...attachMent];
      newAtt.splice(index, 1);
      setAttachment(newAtt);
      if (res) {
        setAttachFile((prev) => prev.filter((i) => i !== attachment));
        setAttachedFiles(newArrayLimit);
        receiveDataFromChild(newArrayLimit);
        setIsValidFileType(true)
      }
      setQuestionsAnswer((prev) => {
        let updatedData = prev.map((item) => {
          if (item.question_id === question?.id) {
            const newSizeArr = [...item.attachments_sizeKb];
            newSizeArr.splice(index, 1);
            return {
              ...item,
              attachments: item?.attachments.filter((i) => i !== attachment),
              attachments_sizeKb: newSizeArr,
            };
          }
          return item;
        });
        const validQuestions = updatedData.filter(
          (q) =>
            q.item?.attachments &&
            q.item?.attachments.length > 0
        );
        saveAnswersToLocalStorage(validQuestions, pendingData?.id)
        return updatedData;
      });
    } catch (error) {
      console.log(error);
    }
  };

  const validateFileType = (filePath) => {
    var allowedExtensions =
      /(\.pdf|\.pptx|\.ppt|\.jpg|\.jpeg|\.png|\.mp3|\.mp4)$/i;

    if (!allowedExtensions.exec(filePath.name) || attachedFiles.length >= 5) {
      setIsValidFileType(false);
      return false;
    }
    setIsValidFileType(true);
    return true;
  };

  async function handleTakePhoto(dataUri) {
    setPhoto(dataUri)
    let attachments = [];
    let attachmentSizes = [];
    const totalSize = attachedFiles.reduce(
      (accumulator, current) => accumulator + current.size,
      0
    );
    // const filename = new Date().getTime() + "data.jpg";
    // const timestamp = new Date().getTime();
    const fileExtension = "jpg" || "jpeg" || "png"; // You can dynamically determine this based on the dataUri MIME type
    const filename = `${`capture`}.${fileExtension}`;
    const link = document.createElement("a");
    link.href = dataUri;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    try {
      const capture = await fetch(dataUri).then((res) => res.blob());
      const fileWithProperExtension = new File([capture], filename, {
        type: capture.type || "image/jpeg",
      });
      if (totalSize + fileWithProperExtension.size < 10 * 1024 * 1024 && validateFileType(fileWithProperExtension)) {
        const formData = new FormData();
        formData.append("name", filename);
        formData.append("uploadResponseAttachment", fileWithProperExtension);
        // formData.append("image", blob, `${new Date().getTime()}.jpg`); // Provide a filename

        let response = await axios.post(
          `/activity/studentResponse/uploadAttachment/studentId/${userId}`,
          formData
        );
        if (response) {
          alert("Photo uploaded successfully!");
          setAttachmentSize((prev) => [...prev, fileWithProperExtension.size]);
          setAttachment((prev) => [...prev, fileWithProperExtension.type]);
          attachments.push(response.data.data);
          setAttachedFiles((prev) => {
            receiveDataFromChild([...prev, fileWithProperExtension]);
            attachmentSizes.push(...attachmentSize, fileWithProperExtension.size);
            return [...prev, fileWithProperExtension];
          });
        } else {
          console.error("Failed to upload photo:", response.statusText);
          alert("Failed to upload photo.");
        }
      } else {
        setIsValidFileType(false);
      }
    } catch (error) {
      console.error("Error uploading photo:", error);
      alert("An error occurred during the upload.");
    }
    if (attachments.length > 0) {
      setAttachFile((prev) => [...prev, ...attachments]);
      console.log(questionsAnswer);
      setQuestionsAnswer((prev) => {
        let updatedData = prev.map((item) => {
          if (item.question_id === question?.id) {
            return {
              ...item,
              attachments: [...item?.attachments, ...attachments],
              attachments_sizeKb: attachmentSizes,
            };
          }
          return item;
        });

        if (!updatedData.some((item) => item.question_id === question?.id)) {
          updatedData.push({
            question_id: question?.id,
            attachments: attachments,
          });
        }
        const validQuestions = updatedData.filter(
          (q) =>
            q.attachments &&
            q.attachments.length > 0
        );
        saveAnswersToLocalStorage(validQuestions, pendingData?.id)
        return updatedData;
      });
    }
  }

  const handleCameraError = (error) => {
    console.error('Camera error:', error);
    alert("Unable to access the camera. Please check your device settings.");
  };

  const handlePdfClick = (attachment) => {
    setTimeout(() => {
      setResponseAttach(attachment);
      setMideaviewer(true)
    }, 100)
  };
  !isValidFileType && (
    toast.error(`Exceeded Limit !!
      Max 5 attachments and total of 10 MB size is allowed.`)
  )
  return (
    <>
      <div className="containerBelowQuestion">
        <div className="d-flex justify-content-between">
          <div className="Question">
            Q{questionNo}. {question?.title?.split("\n").map((line, index) => (
              <React.Fragment key={index}>
                {index !== 0 && <br />}
                <span style={index !== 0 ? { marginLeft: "30px", display: "inline-block" } : {}}>
                  {line}
                </span>
              </React.Fragment>
            ))}
          </div>
          {/* <div className="marksQue ">{question?.correct_score} Marks</div> */}
        </div>
        {question?.attachments?.length > 0 &&
          question?.attachments?.map((attachment, index) => (
            <div key={index}>
              {<>
                {attachment.split(".").pop() === "jpg" ||
                  attachment.split(".").pop() === "jpeg" ||
                  attachment.split(".").pop() === "JPEG" ||
                  attachment.split(".").pop() === "JPG" ||
                  attachment.split(".").pop() === "png" ? (
                  <img
                    style={{ cursor: "pointer" }}
                    className="mt-3 imageWidthAndHeight"
                    src={IP + attachment?.replace(/^\./, "")}
                    alt="Attachment"
                    onClick={() => {
                      if (!isError) {
                        handleClick(attachment);
                      }
                    }}
                  />
                ) : (
                  <div
                    key={index}
                    onClick={(e) => {
                      handlePdfClick(attachment)
                    }}
                    className="mt-2"
                  >
                    <div className="d-flex pdfContainer gap-2 p-2 ">
                      <div className="d-flex align-items-center">
                        <img
                          className="extention_icon"
                          src={`${iconData?.find(
                            (i) =>
                              i.extension ===
                              attachment?.match(/\.([^.]+)$/)[1]
                          )?.icon
                            }`}
                          alt=""
                        />
                      </div>
                      <div className="w-100">
                        <div
                          className="pdfName"
                          title={attachment?.replace(/^[^_]*_/, "")}
                        >
                          {attachment?.replace(/^[^_]*_/, "")}
                        </div>
                        <div className="pdfFileSize">{question.attachments_sizeKb[index] + " KB"}</div>
                      </div>
                    </div>
                  </div>
                )}
              </>}
            </div>
          ))}
        <div>
          <div style={{ position: "relative" }} className="mt-3 mb-3">
            <textarea
              key={question?.id}
              placeholder="Type to write your answer here."
              className="textInputQuestion p-3"
              maxLength={answerLimit}
              value={
                questionsAnswer.find((i) => i.question_id === question?.id || "")
                  ?.description
              }
              onChange={(e) =>
                setQuestionsAnswer((prev) => {
                  let updatedData = prev.map((item) => {
                    if (item.question_id === question?.id) {
                      return {
                        ...item,
                        descriptive_answer: e.target.value,
                        description: e.target.value,
                      };
                    }
                    return item;
                  });
                  if (
                    !updatedData.some(
                      (item) => item.question_id === question?.id
                    )
                  ) {
                    updatedData.push({
                      question_id: question?.id,
                      descriptive_answer: e.target.value,
                      description: e.target.value,
                    });
                  }
                  const validQuestions = updatedData.filter(
                    (q) =>
                      q.description &&
                      q.description?.trim() !== ""
                  );
                  saveAnswersToLocalStorage(validQuestions, pendingData?.id)
                  return updatedData;
                })
              }
            ></textarea>
            <div
              className="maxWordCount"
              style={{
                position: "absolute",
                bottom: "10px",
                right: "10px",
              }}
            >
              {
                questionsAnswer.find((i) => i.question_id === question?.id)
                  ?.descriptive_answer?.length
              }
              /{answerLimit}
            </div>
          </div>
          {/* {question?.attachments?.length > 0 ? (
            <div className="mt-2 d-flex gap-3 pt-2">
              {question?.attachments?.map((attachment, index) => (
                <div
                  key={index}
                  className="ContainerUploadedPdf d-flex gap-2 p-3"
                  onClick={() => {
                    if (!isError) {
                      handleClick(attachment);
                    }
                  }}
                >
                  <div className="d-flex align-items-center">
                    <img
                      className="extention_icon"
                      src={`${iconData?.find(
                        (i) =>
                          i.extension === attachment?.match(/\.([^.]+)$/)[1]
                      )?.icon
                        }`}
                      alt=""
                    />
                  </div>
                  <div className="w-100">
                    <div className="pdfName" title={attachment?.replace(/^[^_]*_/, "")}>
                      {attachment?.replace(/^[^_]*_/, "")}
                    </div>
                    <div className="pdfFileSize">{question.attachments_sizeKb[index] + " KB"}</div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div>
              {!question?.descriptive_answer && <span>No Answers</span>}
            </div>
          )} */}
          <div className="d-flex gap-4 mt-3">
            {!isCameraOpen ? (
              <div
                onClick={() => setIsCameraOpen(true)}
                className="cameraContainerUpload"
              >
                <div style={{ padding: "5px 13px" }}>
                  <div className="d-flex justify-content-center">
                    <img src="/HwImg/CameraIcon.png" alt="" style={{ width: "60" }} />
                  </div>
                  <div className="uploadHereText d-flex justify-content-center mt-2">
                    Upload your files here
                  </div>
                  <div className="openCamera d-flex justify-content-center mt-1">
                    Open Camera
                  </div>
                </div>
              </div>
            ) : (
              <div className="opended_camera">
                <img
                  onClick={() => setIsCameraOpen(!isCameraOpen)}
                  className="cross_icon"
                  src="/DCM-img/crossIcon.svg"
                  alt="cross logo"
                />
                <Camera
                  onTakePhoto={(dataUri) => {
                    handleTakePhoto(dataUri);
                  }}
                  idealFacingMode={"environment"}
                  isImageMirror={false}
                  imageCompression={0.97}
                  isMaxResolution={true}
                  isSilentMode={false}
                  onCameraError={handleCameraError} // Custom error handling
                />
              </div>
            )}
            <div>
              <input
                type="file"
                multiple
                onChange={(e) => {
                  handleAttachment(e.target.files);
                  e.target.value = null;
                }}
                id="attachFile"
                accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
                style={{ display: "none" }}
              />
              <label htmlFor="attachFile" style={{ marginBottom: "0px" }}>
                <div className="cameraContainerUpload">
                  <div style={{ padding: "13px" }}>
                    <div className="d-flex justify-content-center">
                      <img src="/HwImg/UploadFileIcon.png" alt="" style={{ width: "45%" }} />
                    </div>
                    <div className="uploadHereText d-flex justify-content-center mt-2">
                      Upload your files here
                    </div>
                    <div className=" openCamera d-flex justify-content-center mt-1">
                      Choose file
                    </div>
                  </div>
                </div>
              </label>
              {/* {!isValidFileType && (
                <p id="errorMsg">
                  {toast.error(`Exceeded Limit !!
                  Max 5 attachments and total of 10 MB size is allowed.`)}
                </p>
              )} */}
            </div>
          </div>
        </div>
        <div className="d-flex gap-2 align-items-center">
          <div className="d-flex gap-4 flex-wrap">
            {questionsAnswer.find((i) => i.question_id === question?.id)
              ?.attachments?.length > 0 &&
              questionsAnswer
                .find((i) => i.question_id === question?.id)
                ?.attachments?.map((attach, index) => (
                  <div className="d-flex pdfContainer gap-2 p-2 mt-4 " onClick={() => {
                    if (!isError) {
                      handleClick(attach);
                    }
                  }}>
                    <div
                      className="d-flex align-items-center"
                    >
                      <img
                        className="extention_icon"
                        src={`${iconData?.find(
                          (i) => i.extension === attach?.match(/\.([^.]+)$/)[1]
                        )?.icon
                          }`}
                        alt=""
                      />
                    </div>
                    <div
                      onClick={() => setIsOpen(attach)}
                      className=""
                      style={{ width: "75%" }}
                    >
                      <div
                        className="pdfName"
                        title={attach?.replace(/^[^_]*_/, "")}
                      >
                        {attach?.replace(/^[^_]*_/, "")}
                      </div>
                      <div className="pdfFileSize">
                        {Math.floor(attachmentSize[index] / 1024)} KB
                      </div>
                      <div className="d-flex justify-content-end">
                        {/* <img src="/HwImg/PdfRightIcon.png" alt="" /> */}
                      </div>
                    </div>

                    <div
                      className="CrossPdfIcon"
                    >
                      <img src="/HwImg/CrossPdfIcon.png" alt="" onClick={(e) => {
                        handleRemoveAttachment(attach, index)
                        e.stopPropagation();
                      }} />
                    </div>

                  </div>
                ))}
          </div>
          <div>
            {/* {photo ?
              <div style={{ position: "relative" }}>
                <img src={photo} alt="Captured" style={{ width: "100px", marginTop: "20px" }} />
                <img src="/HwImg/CrossPdfIcon.png"
                  style={{ position: "absolute", top: "12px", cursor: "pointer" }}
                  onClick={removePhoto}
                  alt="Up Arrow"
                />
              </div>
              : ""} */}
          </div>
        </div>

      </div>
      {mideaviewer && (
        <PdfViewer
          closeMideaviewer={setMideaviewer}
          attachment={responseAttach}
        />
      )}

      {isClicked &&
        (responseAttach.split(".").pop() === "mp4" || responseAttach.split(".").pop() === "MP4" ? (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              <video className="videoPlayer" controls>
                <source src={IP + responseAttach.replace(/^\./, "")} type="video/mp4" />
              </video>
              <div>
                <img
                  className="crossIconImgQue"
                  onClick={handleClick}
                  src="/DCM-img/crossIcon.svg"
                  alt="Up Arrow"
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              {
                !isError ? (
                  <>
                    <img
                      className="imgMain"
                      src={IP + responseAttach?.replace(/^\./, "")}
                      alt="Full-size"
                      onError={(e) => {
                        setIsError(true)
                      }}
                    />
                    <div>
                      <img
                        className="crossIconImgQue"
                        onClick={handleClick}
                        src="/images/cross.png"
                        alt="Up Arrow"
                      />
                    </div>
                  </>
                ) : (
                  <div className="fullSizeImg" style={{ display: "flex", flexDirection: "column" }}>
                    <img
                      onClick={() => {
                        setIsError(false)
                        handleClick()
                      }}
                      src="/images/cross.png"
                      alt="Up Arrow"
                      style={{ position: "absolute", top: "75px", right: "40%" }}
                    />
                    <img src="/images/no-photo1.png" alt="img" style={{ width: "25%" }} />
                    <p style={{ color: "red", fontSize: "20px", fontWeight: "500", marginRight: "35px" }}>Error!! failed to load the requested file!</p>
                  </div>
                )
              }

            </div>
          </div>
        ))}
    </>
  );
}
